module.exports = __webpack_public_path__ + "img/27_40.4a2ea8f4.png";